export { ta } from '@payloadcms/translations/languages/ta'
